import { createApp } from "vue";
import BalloonTipFloating from "../../backend/components/topcer/plugins/balloonTipFloating";
import PageProduct from "./PageProduct.vue";

const app = createApp({
  components: {
    "page-product": PageProduct,
  },
});
app.directive('balloontip', BalloonTipFloating);
app.mount("#product-page");
